import React from "react";
import cn from "classnames";
import { DrawerModal } from "../drawer-modal/drawer-modal";
import styles from "./add-new-machine-drawer-modal.module.scss";
import { Title } from "@src/components/atoms/title/title";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { NewOnboardingStepper } from "@src/components/atoms/new-onboarding-stepper/new-onboarding-stepper";
import addNewMachineDrawerModalIcon from "@src/assets/svg/add-new-machine-drawer-modal-icon.svg";
import onboardingMachineCompleted from "@src/assets/svg/onboarding-machine-completed.svg";
import onboardingMachineDetailsCompleted from "@src/assets/svg/onboarding-machine-details-completed.svg";
import { useAddNewMachineDrawerModal } from "./use-add-new-machine-drawer-modal-hook";
import { AddNewMachineDrawerModalProvider } from "./add-new-machine-drawer-modal-context";
import { AddNewMachineDetailsStep } from "./add-new-machine-details-step";
import { AddNewMachineSkillsStep } from "./add-new-machine-skills-step";
import { AddNewMachineSummaryStep } from "./add-new-machine-summary-step";

const cssClassName = "add-new-machine-drawer-modal";

export const AddNewMachineDrawerModal = () => {
  const modal = useAddNewMachineDrawerModal();

  return (
    <AddNewMachineDrawerModalProvider value={modal}>
      <DrawerModal
        id="addNewMachineDrawerModal"
        onClose={modal.handleCloseMachineDrawer}
      >
        <div
          className={cn(styles[cssClassName], {
            [styles[`${cssClassName}--locked`]]: modal.isInteractionLocked,
          })}
        >
          <FlexColumnContainer verticalGap={24}>
            <Title tag="h2" text={modal.title} />

            <div className={styles[`${cssClassName}__steps-card`]}>
              <img
                className={styles[`${cssClassName}__steps-icon`]}
                src={
                  modal.isThingsOsStepCompleted
                    ? onboardingMachineCompleted
                    : modal.isMachineDetailsCompleted
                    ? onboardingMachineDetailsCompleted
                    : addNewMachineDrawerModalIcon
                }
                alt=""
              />

              <NewOnboardingStepper steps={modal.steps} />
            </div>

            <p
              className={`${styles[`${cssClassName}__section-title`]} ${
                modal.isMachineSummaryStep
                  ? styles["summary-section-title"]
                  : ""
              }`}
            >
              {modal.sectionTitle}
            </p>

            {modal.isMachineSummaryStep ? (
              <AddNewMachineSummaryStep />
            ) : modal.isMachineSkillsStep ? (
              <AddNewMachineSkillsStep />
            ) : (
              <AddNewMachineDetailsStep />
            )}
          </FlexColumnContainer>
        </div>
      </DrawerModal>
    </AddNewMachineDrawerModalProvider>
  );
};
